import { string, func, bool, oneOfType, number } from 'prop-types'
import Div from '@ui/layout/Div'
import Alert from '@ui/elements/Alert'

const TextType = ({
  name,
  value,
  cssClass = '',
  placeholder,
  label,
  help,
  error,
  onChange = () => { },
  onBlur = () => { },
  type = 'text',
  disabled = false,
  step = 1,
  min = 0,
  max = Infinity,
  prepend = false,
  leftPrepend = false,
  rightPrepend = false,
  isRequired = false
}) => {
  if (value === null) {
    value = ''
  }
  const otherOptions = () => {
    switch (type) {
      case 'number':
        return { step, min, max }
      default:
        break
    }
  }

  return (
    <Div cssClass={`field ${cssClass}`}>
      {label && <label className={`label ${isRequired ? 'is-required' : ''}`} htmlFor={`input-${name}`}>{label}</label>}
      <Div cssClass={`control ${prepend ? 'with-prepends' : ''} ${leftPrepend ? 'with-left-prepend' : ''} ${rightPrepend ? 'with-right-prepend' : ''}`}>
        {leftPrepend ? <span className='left-prepend'>{leftPrepend}</span> : ''}
        <input className='input is-primary' type={type} placeholder={placeholder} id={`input-${name}`} name={name} onChange={onChange} onBlur={e => onBlur(e.target.value)}
          value={value} disabled={disabled} {...otherOptions()} />
        {rightPrepend ? <span className='right-prepend'>{rightPrepend}</span> : ''}
      </Div>
      {help && <p className="help">{help}</p>}
      {error && <Alert cssClass='clear' type='is-danger' message={error} />}
    </Div>
  )
}

TextType.propTypes = {
  name: string,
  onChange: func,
  onBlur: func,
  cssClass: string,
  type: string,
  value: oneOfType([string, number]),
  placeholder: string,
  help: bool,
  step: oneOfType([string, number]),
  min: oneOfType([string, number]),
  max: oneOfType([string, number]),
  label: string,
  disabled: bool,
  prepend: bool,
  leftPrepend: oneOfType([string, bool]),
  rightPrepend: oneOfType([string, bool]),
  error: string,
  isRequired: bool
}

export default TextType
